import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import DropdownFlat from '../Components/DropdownFlat'
import authInstance from '../Classes/AuthHandler';
import {requestPODispatchClearance,GenerateSMSDocument} from '../store/actions/dispatchOrderDetailsActions'
import {getAllSmsDocumentsOfDispatch,getAllDetailsForSupplierDocumentsRegardingDispatch} from '../store/actions/projectNoActions'
import {updateStatusForDispatch} from '../store/actions/orderNoActions'
import {updateDispatchDocumentID} from '../store/actions/dispatchOrderDetailsActions'
import {uploadFileGeneric} from '../store/actions/fileActions'
import {connect} from 'react-redux'
import swal from 'sweetalert'
import env from '../ENV';
import formatDate from '../Classes/FormatDate';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

const ROOT_URL = env.BACKEND_URL;
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

 class DashboardTPM extends React.Component {

    constructor(props) { 
        super(props);
        this.state={
          PoHeader: this.props.location.state.Po,
          checked: this.props.location.state.checked,
          POItem: this.props.location.state.POItem,
          PurchaseOrderId: this.props.location.state.PurchaseOrderId,
          WBSNo : this.props.location.state.WBSNo,
          poLineId:this.props.location.state.poLineId,
          Status : this.props.location.state.Status,
          PurchaseOrderLineItemId: this.props.location.state.PurchaseOrderLineItemId,
          modal: false,
          lorryreceiptmodal:false,
          assigntransportermodal:false,
          poLineItem: this.props.location.state.itemNo,
          PurchaseOrerLineId: this.props.location.state.PurchaseOrerLineId,
          SupplierDocuments:[
          {   value: 1, Name: "Packing Photo(Required)" ,Doc:"Document1.pdf"},
          {   value: 2, Name: "Painting Photo(Required)",Doc:"Document2.pdf" },
          {   value: 3, Name: "Packing List(Required)"  ,Doc:"Document3.pdf" },
          {   value: 4, Name: "Freight Template"        ,Doc:"Document4.pdf" }],

          SMSDocuments:[
            {   value: 1, Name: "Dispatch Clearence/Dispatch Inspection(Required)" ,Doc:"Document1.pdf"}],

           Save: [{  value: 1,  transporter: "ABC supplier"},
                    {  value: 2,  transporter: "CDE supplier"},
                    {  value: 3,  transporter: "EFG supplier"},
                ],
                PoItems:[],
            SMSDocs:[],
            AssignTransporter: [{  value: 1,  transporter: "ABC supplier"},
            {  value: 2,  transporter: "CDE supplier"},
            {  value: 3,  transporter: "EFG supplier"},
            ],
            comments:'',
            selectedFile: [],
            docStatus:{
              1:{title:"Saved as draft",badge:"badge-secondary"},
              2:{title:"Document submitted to SMS",badge:"badge-warning"},
              3:{title:"Accepted",badge:"badge-success"},
              4:{title:"Rejected",badge:"badge-danger"},
              5:{title:"Revised document required",badge:"badge-danger"}
          },
            
          
            
      }
      
      this.savemodal= this.savemodal.bind(this);
      this.comments = this.comments.bind(this);
      this.SendtoVendor = this.SendtoVendor.bind(this);
      this.updateDOcumentIDs = this.updateDOcumentIDs.bind(this);
      this.changeDocStatus = this.changeDocStatus.bind(this);

      this.lorryreceiptmodal=this.lorryreceiptmodal.bind(this);
      this.assigntransportermodal= this.assigntransportermodal.bind(this);
      this.submitAssigntransport= this.submitAssigntransport.bind(this);

    
    }
    
    // ? changes approval status of documents
    async changeDocStatus(status,uploadId,qATemplateStageId){
      this.props.changeDocStatus({status,uploadId,qATemplateStageId});
      this.props.getstagesByPOLineitemID(this.state.purchaseOrderId, this.state.purchaseLIneItemID)
    }

    savemodal() {
    this.setState({savemodal: !this.state.savemodal });         
        if(this.state.savemodal ==true){
            this.setState(
            {opacity:""}
            )
          }
        else{
            this.setState(
              {opacity:"0.2"} 
            )}}

    handleSelect=(e)=>{
      this.setState({
      selectedpaymentmethod : e.target.value
      })      
    }         

    comments(event) { 
      this.setState({comments: event.target.value})
      //  console.log(this.state.comments,"comments") ;
      }

    // handle file upload
    handleFileInput (event) {

      console.log(event)
      let fileList = [...this.state.selectedFile];
      fileList.push(event.target.files[0])
      this.setState({selectedFile:fileList})
      // logging the file array
      console.log(this.state.selectedFile)
  }

  // update document ids
  updateDOcumentIDs = async (results) => {

    console.log("this.state.allSupplierDocs", this.props.smsDoc.allSupplierDocs.recordset)
    results.map(async(el, index)=> {
      await this.props.updateDispatchDocumentID({
        DocumentId: el.DocumentId,
        DocumentTypeId: this.props.smsDoc.allSupplierDocs.recordset[index].DocumentTypeId[0],
        PoID: this.state.PurchaseOrderId,
        PurchaseOrderLineItemId: this.state.PurchaseOrderLineItemId,
        CurrentVersionId: el.VersionId,
        approvalStatus: 2
      })
      this.handleDispatchSupplierDocumentsLoading()
  })
}

  // handle data loading for dispatch supplier documents
  handleDispatchSupplierDocumentsLoading = async() => {
  
    await this.props.getAllDetailsForSupplierDocumentsRegardingDispatch({PurchaseOrderId: this.state.PurchaseOrderId, PurchaseOrderLineItemId: this.state.PurchaseOrderLineItemId})
  
  }

  // handle file upload
  onclickUpload = async (poItem,poId) => {
    console.log(this.state.selectedFile)
    console.log(poItem,poId,"----------")
    // console.log("uploadID", uploadID, "POID=", poID)

    if (this.state.selectedFile.length < 1) {
        swal("Please upload some valid document", { icon: "error" })

        return false;
    }
    swal("Document is uploading...", { button: false, icon: "info" })
    
    // ? File uploading store
    var result = await this.props.uploadFileGeneric(this.state.selectedFile)
    console.log("result", result.results)
    
    await this.updateDOcumentIDs(result.results) 

    // let roles = Object.keys(authInstance.getRoles())[0]
    // await this.props.updateStatusForDispatch(poId,poItem,parseInt(roles))
    let roles = Object.keys(authInstance.getRoles())[0]
    await this.props.updateStatusForDispatch(this.state.PurchaseOrderId,
      this.state.PurchaseOrderLineItemId,
      3)
    // var versionId = result.results[0].VersionId
    // var documentId = result.results[0].DocumentId
    // await this.props.postMapPOAcceptanceDocumentsToPO(versionId, documentId, poID)
}

    submitAssigntransport(){
      console.log(this.state.checked, this.state.comments)
    }

    componentDidMount(){
      this.props.requestPODispatchClearance({ "POCallNo":1})
      // console.log( this.props.requestPODispatchClearance,"******")
      this.props.getAllSmsDocumentsOfDispatch({ "POSAPid": this.state.PoNumber})
      this.props.getAllDetailsForSupplierDocumentsRegardingDispatch({PurchaseOrderId: this.state.PurchaseOrderId, PurchaseOrderLineItemId: this.state.PurchaseOrderLineItemId})
    }
     SendtoVendor = (poItem,poId)=>{
      let roles = Object.keys(authInstance.getRoles())[0]
      let params = []
      this.onclickUpload()
      poItem.map(async(item) => {
        await this.props.updateStatusForDispatch(poId[0],item,2)
        // console.log(poId[0],item,parseInt(roles),"EEEEEEE")
      })
    }
    lorryreceiptmodal() {
      this.setState({ lorryreceiptmodal: !this.state.lorryreceiptmodal });
                
          if(this.state.lorryreceiptmodal ==true){
              this.setState(
               {opacity:""}
              )
             }
          else{
              this.setState(
                  {opacity:"0.2"} 
        )}}
  assigntransportermodal() {
    this.setState({ assigntransportermodal: !this.state.assigntransportermodal });
      
        if(this.state.assigntransportermodal ==true){
            this.setState(
            {opacity:""}
            )
           }
        else{
            this.setState(
               {opacity:"0.2"} 
            )}}
  GenerateDoc = async(poId,polineId) => {
    console.log(this.state.checked.POSAPId,polineId,"Triggered")
    await this.props.GenerateSMSDocument(

    )
  }

    render()
    {
      console.log(this.props.requestPo.requestPoDispatch.recordset, "$$$$$$$$$$$$$")
      var roles = authInstance.getRoles()
      var groups = authInstance.getGroups()
      console.log(this.state.PurchaseOrderId,this.state.PurchaseOrerLineId,"///////////////")
      console.log(this.state.checked,"this.state.checked")
      let poItems= [], wbsNo=[], status= [], poNum=[],Supplier=[],address=[],Email=[],poId = [], polineId=[],PaymentTermCode=[]
      if(roles[12]==true)
      {this.state.checked.map((element) => {
        poItems.push(element.PoItems)
        if(!wbsNo.includes(element.WBSNo)){
          wbsNo.push(element.WBSNo)
        }
        if(!status.includes(element.Status)){
          status.push(element.Status)
        }
        if(!Supplier.includes(element.Supplier)){
          Supplier.push(element.Supplier)
        }
        if(!poNum.includes(element.PoNo)){
          poNum.push(element.PoNo)
        }
        if(!address.includes(element.VendorAddress)){
          address.push(element.VendorAddress)
        }
        if(!Email.includes(element.VendorEmail)){
          Email.push(element.VendorEmail)
        }
        if(!poId.includes(element.POID)){
          poId.push(element.POID)
        }
        if(!polineId.includes(element.PurchaseOrderLineId)){
          polineId.push(element.PurchaseOrderLineId)
        }
      }
        )}
      if(roles[15]==true){
        this.props.smsDoc.allSupplierDocs.recordset && this.props.smsDoc.allSupplierDocs.recordset.map(item=>{
          if(!PaymentTermCode.includes(item.PaymentTermCode)){
            PaymentTermCode.push(item.PaymentTermCode)
          }
        })
      }

        return(
            <div className="Container-fluid pageheight"  >
               <div className="Container-fluid p-4" >
                {/* ---------Assign Transporter Modal Start-------- */}

                <Modal isOpen={this.state.assigntransportermodal} >
            <div className={"modal-bg" + (this.state.assigntransportermodal === 'false'  ? 'open' : '')}>
                <div className="modalheads">
                <ModalHeader HeaderStyle="modal-header modalheaderWide2">
                    <div><h4 >Assign Transporter</h4></div>
                    <button type="button" className="close" aria-label="Close" onClick={this.assigntransportermodal} >
                         <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                </div>
                    <div >
                <ModalBody Style="modal-body modalbodysWide2">
                   

                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>PO No. :</b></div> 
                                <div className="col">{this.state.checked.POSAPId? this.state.checked.POSAPId: this.props.location.state.POItem}</div>    
                            </div>
                            
                        </div>
                        <div className="col-md-6 pt-2">
                            <div className="row">
                                    <div className="col" ><b>Payment Term :</b></div> 
                                    <div className="col ">{PaymentTermCode.toString()}</div>    
                                </div>
                            </div>
                 </div>

                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>PO Date :</b></div> 
                                <div className="col">{formatDate(this.state.checked.PODeliveryDate)}</div>    
                            </div>
                        
                        </div>
                        <div className="col-md-6 pt-2">
                            <div className="row">
                                    <div className="col" ><b>PO Quantity :</b></div> 
                                    <div className="col ">{this.state.checked.POLineItemQuantity+" "+this.state.checked.OrderUnit}</div>    
                                </div>
                            </div>
                 </div>

                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>WBS No. :</b></div> 
                                <div className="col">{this.state.checked.WBSCode}</div>    
                            </div>
                        
                        </div>
                        <div className="col-md-6 pt-2">
                            <div className="row">
                                    <div className="col" ><b>Location :</b></div> 
                                    <div className="col ">{this.state.checked.Location}</div>    
                                </div>
                            </div>
                 </div>

          
                   <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Assign Transporter :</b></div> 
                       <div className="col-md-7">
                       <DropdownFlat defaultopt="Select Option"  data={this.state.AssignTransporter} actions={this.handleSelect} keyObjName={"value"} valueObjName={"transporter"} />
                         </div>
                   </div>

                 <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Comments <em>(if any)</em> :</b></div> 
                       <div className="col-md-7">
                         <textarea className="form-control" rows="2" value={this.state.comments} onChange={this.comments}></textarea>
                         </div>
                   </div>
                </ModalBody>
                </div>
                <div>    
                <ModalFooter FooterStyle="modal-footer modalfooterWide2">
                <div>
                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.submitAssigntransport} type="submit">Confirm</button>              
                  <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.assigntransportermodal} type="submit">Cancel</button>               
                </div>

                    
                </ModalFooter>
                </div>
                </div>
                </Modal>

                {/* ---------Assign Transporter Modal End-------- */}

                {/* ---------Upload Lorry Receipt Modal Start-------- */}

               <Modal isOpen={this.state.lorryreceiptmodal} >
            <div className={"modal-bg" + (this.state.lorryreceiptmodal === 'false'  ? 'open' : '')}>
                <div className="modalheads">
                <ModalHeader HeaderStyle="modal-header modalheaderWide2">
                    <div><h4 >Upload Lorry Receipt</h4></div>
                    <button type="button" className="close" aria-label="Close" onClick={this.lorryreceiptmodal} >
                         <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                </div>
                    <div >
                <ModalBody Style="modal-body modalbodysWide2">
                   

                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>PO No. :</b></div> 
                                <div className="col">ABC</div>    
                            </div>
                        
                        </div>
                        
                 </div>


                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>PO Item :</b></div> 
                                <div className="col">ABC</div>    
                            </div>
                        
                        </div>
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col" ><b>WBS No. :</b></div> 
                                <div className="col">ABC</div>    
                            </div>
                        
                        </div>
                        
                 </div>


                   <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Lorry Receipt :</b></div> 
                       <div className="col-md-7">
                          <FontAwesomeIcon className="align-middle pr-2" icon={"upload"}  color={"black"} title="Upload" size="2x"/>
                         </div>
                   </div>

                 <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Comments <em>(if any)</em> :</b></div> 
                       <div className="col-md-7">
                         <textarea className="form-control" rows="2" value={this.state.comments} onChange={this.comments}></textarea>
                         </div>
                   </div>
                 
                </ModalBody>
                </div>
                <div>    
                <ModalFooter FooterStyle="modal-footer modalfooterWide2">
                <div>
                <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={this.modal} type="submit">Confirm</button>
                
                  <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.lorryreceiptmodal} type="submit">Cancel</button>
                
                
                
                </div>

                    
                </ModalFooter>
                </div>
                </div>
                </Modal>

                {/* ---------Upload Lorry Receipt Modal End-------- */}

            {/* ---------Upload Dispatch Clearance Modal Start-------- */}
              <Modal isOpen={this.state.savemodal} >
                  <div className={"modal-bg" + (this.state.savemodal === 'false'  ? 'open' : '')}>
                  <div className="modalheads">
                <ModalHeader HeaderStyle="modal-header modalheaderWide2">
                    <div><h4 >Upload Dispatch Clearance </h4></div>
                    <button type="button" className="close" aria-label="Close" onClick={this.savemodal} >
                         <span aria-hidden="true">&times;</span>
                    </button>
                </ModalHeader>
                </div>
                 <div >
                <ModalBody Style="modal-body modalbodysWide2">
                     
                 <div className="row ml-2 pt-2 ">
                        <div className="col-md-6 pt-2 " >
                            <div className="row">
                                <div className="col-md-6" ><b>Email :</b></div> 
                                <div className="col-md-6">
                                  {/* <input type='text' placeholder="abc@gmail.com"></input> */}
                                  {Email}
                                  </div>    
                            </div>                     
                        </div>
                        </div>
                   <div className="row ml-2 mt-1 pt-2">
                       <div className="col-md-3"><b>Signature :</b></div> 
                       <div className="col-md-7">
                       <FontAwesomeIcon className="align-middle pr-2" icon={"upload"}  color={"black"} title="Upload" size="2x"/>
                       </div>
                   </div>
                   <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Vendor Address :</b></div> 
                       <div className="col-md-7"> {address}
                    
                       </div>
                   </div>
                   
                 <div className="row ml-2 pt-2">
                       <div className="col-md-3"><b>Comments <em>(if any)</em> :</b></div> 
                       <div className="col-md-7">
                         <textarea className="form-control" rows="2" value={this.state.comments} onChange={this.comments}></textarea>
                         </div>
                   </div>          
                </ModalBody>
                </div>
                <div>    
                <ModalFooter FooterStyle="modal-footer modalfooterWide2">
                <div>
                  <button className="btn2 btn-sms1 mt-2 ml-4 float-right" onClick={()=>this.GenerateDoc(poId,polineId)}>Generate</button>
                  <button className="btn2 btn-sms3 mt-2 ml-4 float-right" onClick={this.savemodal} type="submit">Cancel</button>
                            
                </div>
                
                </ModalFooter>
                </div>
                </div>
                </Modal>

                 
                {/* ---------Upload Dispatch Clearance for TPM Modal End-------- */}
                
              
              
                <div className="row ">     
                         <div className="col-md-10 header pt-2"><b>DISPATCH - DOCUMENTS DASHBOARD</b></div>
                </div> 


              <div className="col-md-12 pt-2 pl-2 pb-2 border" style={{"backgroundColor": "#bdc3c7"}}>PO Details</div> 
              {roles[12]==true ?  
              <>
               <div>
                      <div className="col-md-3 pt-2  ">
                       <b>PO No: </b> {poNum.toString()}
                    </div>
                    <div className="col-md-3 pt-2  ">
                    <b>PO Item: </b> {poItems.toString()} 
                    </div>
                    <div className="col-md-6 pt-2  ">
                    <b>Vendor Name: </b> 
                    {Supplier.toString()} 
                    </div>
                    <div className="col-md-3 pt-2 ">
                    <b>WBS No:</b>  {wbsNo.toString()}
                    </div>  
                    <div className="col-md-10 pt-2 ">
                    <b>Status: </b>  {status.toString()}
                    </div>
               </div>
               </>
          
               : roles[15]==true ? 
               <>
                <div className="row">

                  <div className="col-md-10">
                    <div className="col-md-3 pt-2  ">
                       <b>PO No: </b> {this.state.checked.POSAPId}
                    </div>
                    <div className="col-md-3 pt-2  ">
                     <b>PO Item: </b> {this.state.checked.POLineItemSAPCode} 
                    </div>
                    <div className="col-md-3 pt-2 ">
                     <b>WBS No:</b>  {this.state.checked.WBSCode}
                    </div>  
                    <div className="col-md-10 pt-2 ">
                     <b>Status: </b>  {this.state.checked.dispatchStatusName}
                    </div>
                  </div>
                  <div className="col-md">
                    <button className="btn2 btn-sms2 float-right" onClick={this.assigntransportermodal}>Assign</button>
                  </div>
                </div>
                </>
             :
             roles[5] || roles[6]?
             <>
             <div>
                     <div className="col-md-3 pt-2  ">
                     <b>PO No: </b> {this.state.PoHeader}
                   </div>
                   <div className="col-md-3 pt-2  ">
                   <b>PO Item: </b> {this.state.POItem} 
                   </div>
                   <div className="col-md-3 pt-2 ">
                   <b>WBS No:</b>  {this.state.WBSNo}
                   </div>  
                   <div className="col-md-10 pt-2 ">
                   <b>Status: </b>  {this.state.Status}
                   </div>
             </div>
             </>
             :
              <></> }    
                <br />
                
                <div className="row pl-2 pr-4">
                   <div className="col-md-12 ml-2 pt-2 pl-2 pb-2 border" style={{"backgroundColor": "#bdc3c7"}}>Documents Dashboard</div> 
                   
                </div>
                <div>
                    <div className="row pl-2 pt-2 pr-4">
                      <div className="col-md-12 ml-2 pt-2 pl-2 pb-2 dispatch-bg border">SMS Documents</div> 
                    </div>

                    <div className="row pl-2 pr-4">
                      <div className="col ml-2 pr-2 ">
                        {/* {this.props.smsDoc.allSmsDocs && this.props.smsDoc.allSmsDocs.recordset && this.props.smsDoc.allSmsDocs.recordset.length>0 && this.props.smsDoc.allSmsDocs.recordset.map((element,Index)=> */}
                      {this.state.SMSDocuments.map((element,Index)=>
                        
                          <div className="row border pt-2 pl-2 pb-2 ">
                              
                              <div className="col-md-6 pt-2 pl-2 pb-2 border">Dispatch Clearance/Inspection Required</div>
                              <div className="col-md-6 pt-2 pl-2 pb-2 border textcolor">
                               
                                <div className="row">
                                  <div className="col">
                                    
                                  {element.DispatchClearance}
                                  </div>
                                  {/* <div className="col">
                                    <FontAwesomeIcon className="align-middle pr-2" icon={"upload"}  color={"black"} title="Upload" size="2x"/>
                                  </div> */}
                                </div>
                                {/* <button className="btn2 btn-sms1 mt-4 rounded  float-right " onClick={this.savemodal}>Save</button> */}
                                 {roles[12] ?
                                <button className="btn2 btn-sms1 rounded  float-right mt-2 "   onClick={this.savemodal}>Create</button>
                                // :
                                // roles[6] && roles[16] && roles[15] ?
                                // <>
                                //    <div className="text-center">
                                //     <FontAwesomeIcon  icon={"eye"}  color="black" title="View" size="lg" />
                                //  </div>

                                // </>

                                :
                               
                                 !roles[6] && !roles[16] && !roles[15] ?
                                 <>
                                 {/* <button className="btn2 btn-sms3 rounded  float-right   ">View</button> */}
                                 <div className="text-center">
                                    <FontAwesomeIcon  icon={"download"}  color="black" title="View" size="lg" />
                                 </div>
                                </>
                                :
                                <>
                                   <div className="text-center">
                                    <FontAwesomeIcon  icon={"eye"}  color="black" title="View" size="lg" />
                                 </div>

                                </>
                  
                        
                                    }
                                    
                                   
                                  </div>
                                
                          </div>
                       ) 
                                  } 
                      </div>
                    </div>
                </div>
                <div>
                    <div className="row pl-2 pr-4">
                      {roles[12]? null : <div className="col-md-12 ml-2 pt-2 pl-2 pb-2 dispatch-bg border">Supplier Documents</div> }
                    </div>

                    <div className="row pl-2 pr-4 ">
                      <div className="col ml-2 pr-2 ">
                         
                         {this.props.smsDoc.allSupplierDocs && this.props.smsDoc.allSupplierDocs.recordset && this.props.smsDoc.allSupplierDocs.recordset.length>0 && this.props.smsDoc.allSupplierDocs.recordset.map((item,index)=>
                         
                          <div className="row border  ">
                              
                              <div className="col-md-6 border">
                                {item.IsRequired == true ? item.DocumentTypeName + " " + "(Required)" : item.DocumentTypeName + " " + "(Optional)" }
                                
                              </div>
                              <div className="col-md-6 border textcolor">
                                <div className="row">
                                  {/* <div className="col-md-8 mt-2 mb-2">
                                  {item.Doc}
                                  </div> */}
                                
                                  <div className="col-md-12 mt-2 mb-2">
                                   {roles[5]?
                                   item.DocumentId? (<div className="col-ml-2 text-center" style={{marginRight:"10px"}}>
                                   <a href={FILESERVER_ROOT_URL + "files/Documents/"+item.DocumentId+"/download"} target="_blank" download> 
                                       <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{marginLeft:"10px",marginRight:"5px"}} icon={"download"}  color={"black"} title="Download" size="2x"/> 
                                   </a>
                                   <FontAwesomeIcon 
                                       className="align-middle mt-2 pr-2" 
                                       icon={"code-branch"}  
                                       color={"black"} 
                                       title="Document Version" 
                                       size="2x" onClick={()=>this.OpenVersionModal(item.DocumentId)} />
                                       <FontAwesomeIcon className="align-middle mt-2 pr-2" icon={"sms"}  color={"black"} title="Comments" size="2x" 
                                      //  onClick={()=>this.documentComments({actionType:"Supplier Documents",param:el},el.uploadId)}
                                       />
                                   <><br/><span className={"badge "+this.state.docStatus[item.approvalStatus]['badge']} style={{marginTop:"5px"}}>
                                                   {item.approvalStatus==2 ? this.state.docStatus[item.approvalStatus]['title']: "Saved"}
                                   </span></>
                                   
                                       
                               
                               </div>)  : <div className="row">
                                    <div className="col-md"><input type="file" className="form-control-file" onChange={(e) => {this.handleFileInput(e)}} id="exampleFormControlFile1"/></div>
                                    {/* <div className="col-md"><FontAwesomeIcon icon={"upload"}  color="black" title="View" size="lg" /></div> */}
                                    </div>
                                    :
                                    <></>}
                                     {/* only qaplanner(6) and importexport(16) can approve reject others only view */}
                                    {roles[1]||roles[6]||roles[9]||roles[12]||roles[16]||roles[13] ||roles[14]||roles[15]||roles[16]?<>  
                                      {roles[6]||roles[16] ?<>
                                        <button className="btn2 btn-sms1 rounded  float-right ">Reject</button>
                                        <button className=" btn2 btn-sms2 rounded  float-right ">Approve</button>
                                      </>:<></>} 
                                        {/* <button className="btn2 btn-sms3 rounded  float-right   ">View</button> */}
                                        <FontAwesomeIcon icon={"eye"}  color="black" title="View" size="lg" />
                                      
                                    </>:<></>}                            
                                  </div>
                                </div>
                                
                             </div>
                              
                          </div>
                          )}
                      </div>
                    </div>
                    {roles[12]?<>
                      <Link  to ={{ pathname: '',state : { } }}>
                       <button className="btn2 btn-sms1 mt-4 rounded  float-right btn-success" onClick={()=>{this.SendtoVendor(polineId,poId)}}>Send to Vendor</button>

                     </Link></>:<></>}
                     {/* for finance(9),logistics(13),commercial(14),purchase team(15) no save button */}
                     {/* for TPM9(12),Supp(5),importexport(16),qa(6) save button is there */}
                     {/* {roles[5]&&roles[6]&&!roles[9]&&!roles[13]&&!roles[14]&&!roles[15]&&roles[12]&&roles[16] ?<>
                    <Link  to ={{ pathname: '',state : { } }}>
                    <button className="btn2 btn-sms1 mt-4 rounded  float-right ">Save</button>
                   </Link></>:<></>} */}
                   {roles[5]||roles[6]||roles[16]?<>
                   {
                     !roles[9]||!roles[13]||!roles[14]||!roles[15]||roles[12]?<>
                     {/* <button  className="btn2 btn-sms1 mt-4 rounded  float-right " onClick={()=>{this.onclickUpload(this.state.PurchaseOrerLineId,this.state.PurchaseOrderId)}} >Send To SMS</button> */}
                        <button hidden={(this.props.smsDoc.allSupplierDocs && this.props.smsDoc.allSupplierDocs.recordset && this.props.smsDoc.allSupplierDocs.recordset.length == 0? true : (this.props.smsDoc.allSupplierDocs && this.props.smsDoc.allSupplierDocs.recordset && (this.props.smsDoc.allSupplierDocs.recordset.length == this.props.smsDoc.allSupplierDocs.recordset[0].isAllRequiredUploaded))? true : false)} className="btn2 btn-sms1 mt-4 rounded  float-right " onClick={()=>{this.onclickUpload(this.state.PurchaseOrerLineId,this.state.PurchaseOrderId)}}>Submit documents to SMS</button>
                   </> :
                   <></>
                   }
                    </>:<></>}

                   
          
                </div>
                
                
  
            </div>
            </div>
            
        )
    }
}

const mapStateToProps  = (state) => ({requestPo:state.dispatchOrderDetailsReducer, smsDoc:state.projectNoReducer, updateStatus:state.orderNoReducer})
export default connect(mapStateToProps,{getAllDetailsForSupplierDocumentsRegardingDispatch, requestPODispatchClearance,getAllSmsDocumentsOfDispatch, updateStatusForDispatch, uploadFileGeneric, GenerateSMSDocument, updateDispatchDocumentID}) (DashboardTPM)
